import React, { useEffect, useState } from 'react';
import { IconLogo } from '../components/Icons.jsx';

const API_BASE = import.meta.env.VITE_API_BASE || '/api';

export default function AuthVerify() {
  const [status, setStatus] = useState('verifying');
  const [debugInfo, setDebugInfo] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      window.location.replace('/login?error=missing');
      return;
    }

    const verifyUrl = `${API_BASE}/auth/verify?token=${encodeURIComponent(token)}`;

    fetch(verifyUrl, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    })
      .then(async (res) => {
        const text = await res.text();
        let data;
        try { data = JSON.parse(text); } catch { data = null; }

        if (res.ok && data && data.token) {
          // Store JWT in localStorage FIRST, then verify it was stored
          try {
            localStorage.setItem('aigo_token', data.token);
            localStorage.setItem('aigo_gym_id', data.gym_id || '');

            // Verify the write succeeded
            const stored = localStorage.getItem('aigo_token');
            if (!stored) {
              setDebugInfo('localStorage write failed - storage may be full or disabled');
              setStatus('error');
              return;
            }

            setStatus('success');
            // Small delay to ensure localStorage is committed, then redirect
            setTimeout(() => {
              window.location.replace('/');
            }, 200);
            return;
          } catch (storageErr) {
            setDebugInfo(`Storage error: ${storageErr.message}`);
            setStatus('error');
            return;
          }
        }

        // Failed
        setDebugInfo(`API responded: ${res.status} - ${text.substring(0, 100)}`);
        setStatus('expired');
      })
      .catch((err) => {
        setDebugInfo(`Network error: ${err.message}`);
        setStatus('error');
      });
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      padding: 24,
      color: 'var(--text-secondary)',
      fontSize: 'var(--text-base)',
      textAlign: 'center',
    }}>
      <IconLogo size={40} style={{ color: 'var(--primary)' }} />
      {status === 'verifying' && <p>Signing you in...</p>}
      {status === 'success' && <p>Success! Loading your dashboard...</p>}
      {status === 'expired' && (
        <>
          <p style={{ fontWeight: 600 }}>This link has expired.</p>
          <p>Go back to <a href="/login" style={{ color: 'var(--primary)' }}>sign in</a> and request a new one.</p>
          {debugInfo && <p style={{ fontSize: 11, opacity: 0.4, maxWidth: 300, wordBreak: 'break-all' }}>{debugInfo}</p>}
        </>
      )}
      {status === 'error' && (
        <>
          <p style={{ fontWeight: 600 }}>Something went wrong.</p>
          <p>Go back to <a href="/login" style={{ color: 'var(--primary)' }}>sign in</a> and try again.</p>
          {debugInfo && <p style={{ fontSize: 11, opacity: 0.4, maxWidth: 300, wordBreak: 'break-all' }}>{debugInfo}</p>}
        </>
      )}
    </div>
  );
}
